import _classCallCheck from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { ResizeSimpleAction } from "./ResizeSimpleAction.js";
import { GravityQualifier } from "../../qualifiers/gravity/GravityQualifier.js";
/**
 * @description Defines a scaling resize action.
 * @extends Actions.Resize.ResizeSimpleAction
 * @memberOf Actions.Resize
 * @see Visit {@link Actions.Resize| Resize} for examples
 */

var ResizeScaleAction = /*#__PURE__*/function (_ResizeSimpleAction) {
  _inherits(ResizeScaleAction, _ResizeSimpleAction);

  var _super = _createSuper(ResizeScaleAction);

  function ResizeScaleAction() {
    _classCallCheck(this, ResizeScaleAction);

    return _super.apply(this, arguments);
  }

  _createClass(ResizeScaleAction, [{
    key: "liquidRescaling",
    value:
    /**
     * @description Changes the aspect ratio of an image while retaining all important content and avoiding unnatural
     * distortions.
     * @return {this}
     */
    function liquidRescaling() {
      return this.addQualifier(new GravityQualifier('liquid'));
    }
  }]);

  return ResizeScaleAction;
}(ResizeSimpleAction);

export { ResizeScaleAction };